const state = {
  flags: {},
  customContentCoursesEnabled: false,
  customContentVideosEnabled: false,
}

export default state
